module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_3.69ba4578.png";